export default __webpack_public_path__ + "static/media/frame20x30-black.2f9c9009.png";